/**
 * RequestPowersSection - Read-only powers display for requesting side
 * Shows bond powers after a quote has been accepted
 */

import { useState, useEffect } from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { getTransferPowers } from '../../../../services/oathTransferBondService';
import { OathSectionCard } from '../../../shared/OathUI';
import PowersTable from '../shared/PowersTable';

const RequestPowersSection = ({ bondDetails }) => {
  const [powers, setPowers] = useState([]);
  const [loading, setLoading] = useState(true);

  const transactionId = bondDetails?.transferBondTransactionID;
  // Only show powers when there's an executing agent (quote accepted)
  const shouldShow = !!bondDetails?.executingAgentID;

  useEffect(() => {
    if (!transactionId || !shouldShow) {
      setLoading(false);
      return;
    }

    const fetchPowers = async () => {
      setLoading(true);
      const response = await getTransferPowers(transactionId);
      if (response.success) {
        setPowers(response.data || []);
      }
      setLoading(false);
    };

    fetchPowers();
  }, [transactionId, shouldShow]);

  if (!shouldShow) return null;

  return (
    <OathSectionCard title="Bond Powers" icon={DocumentTextIcon} className="mb-6">
      <PowersTable
        powers={powers}
        showActions={false}
        loading={loading}
        emptyMessage="No powers have been assigned yet."
      />
    </OathSectionCard>
  );
};

export default RequestPowersSection;
